module.exports = __webpack_public_path__ + "static/media/node-2.3c6fc80b.svg";